module.exports = __webpack_public_path__ + "static/media/Wayne.98a98793.jpg";